import { AppConfig } from './classes/appConfig';
import { TicketInfo } from './classes/efectivoReembolsable';
export { IAseguradora  } from './interfaces/aseguradora';
export { ICita  } from './interfaces/cita';
export { IContacto  } from './interfaces/contacto';
export { ICitaDetalle  } from './interfaces/citaDetalle';
export { IStatusCita  } from './interfaces/statusCita';
export { IFoto  } from './interfaces/foto';

export { Foto  } from './classes/foto';
export { Archivo } from './classes/archivo';
export { Proceso } from './classes/proceso';
export { Cita  } from './classes/cita';
export { CitaDetalle  } from './classes/citaDetalle';
export { Valuacion } from './classes/valuacion';
export { Cotizacion } from './classes/cotizacion';
export { ValuacionDetalle } from './classes/valuacionDetalle';
export { CotizacionDetalle } from './classes/cotizacionDetalle';
export { Aseguradora } from './classes/aseguradora';
export { Sucursal } from './classes/sucursal';
export { Unidad, LlantaUnidad, EstadoUnidad } from './classes/unidad';
export { Marca } from './classes/marca';
export { AutorizacionSeguro } from './classes/autorizacionSeguro';
export { Inventario } from './classes/inventario';
export { StatusOrdenServicio } from './classes/statusOrdenServicio';
export { DemoConfig } from './classes/demoConfig';

export { Presupuesto } from './classes/presupuesto';
export { PresupuestoDetalle } from './classes/presupuestoDetalle';
export { PlanTrabajo } from './classes/planTrabajo';
export { TipoPlanTrabajo } from './classes/tipoPlanTrabajo';
export { Rol } from './classes/rol';
export { RolUsuario } from './classes/rolUsuario';
export { SucursalRol } from './classes/sucursalRol';
export { Proveedor } from './classes/proveedor';

export { Reparacion  } from './classes/reparacion';
export { ReparacionDetalle } from './classes/reparacionDetalle';
export { UnidadTerminada } from './classes/unidadTerminada';
export { EntregaUnidad, FacturacionEntrega } from './classes/entregaUnidad';

export { OrdenServicio } from './classes/ordenServicio';
export { Cliente } from './classes/cliente';
export { Usuario } from './classes/usuario';
export { Empleado } from './classes/empleado';
export { CurrentUser } from './classes/currentUser';
export { Costo } from './classes/costo';
export { Compras, PendienteCotizar, CotizacionCompras, PagarFactura,
    PrecioProveedor, CuentasxPagar, CuentaProveedor, FacturaProveedor,
    ProcesoCompra, DetalleFacturaProveedor, ResumenCuentaProveedor, 
    PagarFacturaProveedor } from './classes/compras';
export { Complemento  } from './classes/complemento';
export { OrdenServicioPago } from './classes/pagos';

export { PendienteAlmacen, OrdenServicioAlmacen, EntradaAlmacen,
    UnidadMedida, PlanTrabajoAlmacen, DetalleInventarioSucursal,
    ImprimirOrdenServicio, OrdenServicioInventario } from './classes/almacen';

export { OrdenAbierta, OrdenCerrada, Facturacion } from './classes/facturacion';

export { DatosOrdenServicio } from './classes/datosOrdenServicio';

// REPORTES
export { HistoricoUnidad, UnidadIngresada, UnidadAnual, TotalMes,
    DetalleUnidadProceso, UnidadProceso, Estimado, AurotizadoAseguradora,
    ImprimirRecepcion, ReporteGlobalMes, ReporteFacturacion,
    FacturadoMesSucursal, FacturadoMes, ReporteFacturadoAnual, ReporteFacturadoSucursal,
    PendienteAseguradoraSucursal, PendienteAseguradora, ReportePendientesxAseguradora, 
    ReporteUtilidad  } from './classes/reportes';

export { Image  } from './classes/image';
export { DashboardOS } from './classes/dashboardos';
export { ChatMensaje } from './classes/chat';
export { ResultData } from './classes/resultData';
export { TicketInfo, Ticket, Beneficiario, OrdenServicioReembolsable } from './classes/efectivoReembolsable';
export { InventarioTaller, StatusInventario } from './classes/inventarioTaller';
export { AppConfig } from './classes/appConfig';
export { LoginConfig } from './classes/loginConfig';
export { FacturaSAT } from './classes/facturaSAT';






// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/trjireh-model.ts